import * as React from 'react';
import { FC } from 'react';

import { IMarketingTileBasic } from 'generated/sanity-graphql';

import { MarketingTileList } from '../marketing-tile-group/marketing-tile-list';

import {
  ButtonWrapper,
  Container,
  DescriptionTextBlock,
  HeadingText,
  ImageContainer,
  StyledButton,
  StyledLoyaltyLogo,
  SubtitleText,
  Terms,
  TitleText,
} from './empty-state.styled';
import { IEmptyStateProps } from './types';

const EmptyState: FC<IEmptyStateProps> = ({ content }) => {
  const {
    image,
    headerText,
    title,
    subtitle,
    description,
    buttonAction,
    marketingTileList,
    terms,
  } = content;
  const mainImage = image?.locale?.app;
  const header = headerText?.locale;
  const titleText = title?.locale;
  const subtitleText = subtitle?.locale;
  const termsText = terms?.locale;
  const descriptionContent = description?.locale;
  const tiles = (marketingTileList?.tiles as IMarketingTileBasic[]) || [];

  return (
    <Container>
      <StyledLoyaltyLogo />
      {header && <HeadingText>{header}</HeadingText>}
      {mainImage && (
        <ImageContainer
          image={mainImage}
          alt={image?.locale?.imageDescription || 'Empty Image'}
          objectFitContain
        />
      )}
      {titleText && <TitleText>{titleText}</TitleText>}
      {subtitleText && <SubtitleText>{subtitleText}</SubtitleText>}
      {descriptionContent && <DescriptionTextBlock content={descriptionContent} />}
      <MarketingTileList tiles={tiles} />
      {buttonAction?.actionText && (
        <ButtonWrapper>
          <StyledButton fullWidth to={buttonAction.actionUrl?.locale || ''}>
            {buttonAction.actionText.locale}
          </StyledButton>
        </ButtonWrapper>
      )}
      {termsText && <Terms content={termsText} />}
    </Container>
  );
};

export default EmptyState;
